var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._b({tag:"component",attrs:{"to":_vm.path,"href":_vm.path,"path":_vm.path},nativeOn:{"click":function($event){return _vm.$emit('click')}}},'component',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }